import React, { useState, useEffect } from "react";
import "./App-White-Gray.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import BlogPost from "./components/BlogPost";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import SingaporeIndiaExpansion from "./components/SingaporeIndiaExpansion";
import FloatingCTA from "./components/FloatingCTA";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import { Toaster } from "sonner";

// Protected Route Component
const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (!isAuthenticated) {
    return <Navigate to="/manage-bz/login" replace />;
  }
  return children;
};

// Component to handle hash-based scrolling after navigation
const ScrollToHash = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Only process if we have a hash and we're on the home page
    if (location.hash && location.pathname === '/') {
      const sectionId = location.hash.replace('#', '');
      // Small delay to ensure the page has rendered
      const timer = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);
  
  return null;
};

// Layout wrapper to conditionally show Header/Footer
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/manage-bz');
  
  return (
    <>
      <ScrollToHash />
      {!isAdminRoute && <Header />}
      {children}
      {!isAdminRoute && <FloatingCTA />}
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  useEffect(() => {
    // Check if admin token exists on mount
    const token = localStorage.getItem('adminToken');
    if (token) {
      setIsAdminAuthenticated(true);
    }
  }, []);

  const handleAdminLogin = () => {
    setIsAdminAuthenticated(true);
  };

  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <LayoutWrapper>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/singapore-india-expansion" element={<SingaporeIndiaExpansion />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            
            {/* Admin Routes */}
            <Route 
              path="/manage-bz/login" 
              element={
                isAdminAuthenticated ? 
                  <Navigate to="/manage-bz/dashboard" replace /> : 
                  <AdminLogin onLogin={handleAdminLogin} />
              } 
            />
            <Route 
              path="/manage-bz/dashboard" 
              element={
                <ProtectedRoute isAuthenticated={isAdminAuthenticated}>
                  <AdminDashboard onLogout={handleAdminLogout} />
                </ProtectedRoute>
              } 
            />
            <Route path="/admin" element={<Navigate to="/manage-bz/login" replace />} />
            <Route path="/admin/login" element={<Navigate to="/manage-bz/login" replace />} />
            <Route path="/admin/dashboard" element={<Navigate to="/manage-bz/login" replace />} />
          </Routes>
        </LayoutWrapper>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
